"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticCountdownTimer = void 0;

var _luxon = require("luxon");

var _react = _interopRequireDefault(require("react"));

var _TimerIcon = require("../../svgs/TimerIcon");

var _useCurrentTime = require("../../utils/useCurrentTime");

var _Flex = require("../Flex");

var _ProgressBarTimer = require("../ProgressBarTimer");

var _Spacer = require("../Spacer");

var _StackableBorderBox = require("../StackableBorderBox");

var _TimeRemaining = require("../TimeRemaining");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FIVE_HOURS_IN_SECONDS = 60 * 60 * 5;
/**
 * StaticCountdownTimer
 * @deprecated
 */

var StaticCountdownTimer = function StaticCountdownTimer(_ref) {
  var action = _ref.action,
      note = _ref.note,
      countdownEnd = _ref.countdownEnd,
      countdownStart = _ref.countdownStart,
      currentTime = _ref.currentTime;

  var endDateTime = _luxon.DateTime.fromISO(countdownEnd).toLocal();

  var minutes = endDateTime.minute < 10 ? "0" + endDateTime.minute : endDateTime.minute;
  var amPm = endDateTime.hour >= 12 ? "pm" : "am";
  var hour;

  if (endDateTime.hour > 12) {
    hour = endDateTime.hour - 12;
  } else if (endDateTime.hour === 0) {
    hour = 12;
  } else {
    hour = endDateTime.hour;
  }

  var time = "".concat(hour, ":").concat(minutes).concat(amPm);
  var actionDeadline = "".concat(endDateTime.monthShort, " ").concat(endDateTime.day, ", ").concat(time, " ").concat(endDateTime.offsetNameShort);
  var highlight = endDateTime.diff(_luxon.DateTime.fromISO((0, _useCurrentTime.useCurrentTime)(currentTime).toString()), "seconds").seconds < FIVE_HOURS_IN_SECONDS ? "red100" : "purple100";
  return /*#__PURE__*/_react.default.createElement(_StackableBorderBox.StackableBorderBox, {
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_TimerIcon.TimerIcon, {
    width: "14",
    height: "17",
    fill: highlight,
    style: {
      marginTop: "1.5px"
    }
  }), /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    mr: "7px"
  }), /*#__PURE__*/_react.default.createElement(_TimeRemaining.TimeRemaining, {
    countdownEnd: countdownEnd,
    highlight: highlight,
    currentTime: (0, _useCurrentTime.useCurrentTime)(currentTime),
    timeEndedDisplayText: "0 days left",
    trailingText: "left"
  })), /*#__PURE__*/_react.default.createElement(_ProgressBarTimer.ProgressBarTimer, {
    countdownStart: countdownStart,
    countdownEnd: countdownEnd,
    currentTime: (0, _useCurrentTime.useCurrentTime)(currentTime),
    highlight: highlight
  }), /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
    size: "2",
    weight: "medium",
    color: "black100"
  }, action, " by ", actionDeadline), /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
    size: "2",
    color: "black60"
  }, note));
};

exports.StaticCountdownTimer = StaticCountdownTimer;
StaticCountdownTimer.displayName = "StaticCountdownTimer";
//# sourceMappingURL=StaticCountdownTimer.js.map